
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvBookingRoomSelector.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { EvBookingCopyForm } from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../moreCore/UI/EntityBased/HintBox/HintBox"
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
class EvBookingRoomSelector extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    roomInput: MdsLax<InstanceType<typeof HintBox>>;

    protected afterSetData() {
        let data = this.sourceData as VAM2types.EvRoomEntity;
    }

    protected onDirtyChange(currentState: boolean) {
        
    }

    protected _onChanged(key: string, value: any) {
        //this.setStylesBasedOnData(); // bissl extrem? wird bei jeder kleinen Änderung aufgerufen
    }

    private _onChanged_EvRoom(key: string, newValue: VAM2types.EvRoomEntity, oldValue: any) {
        if (newValue) {

        }
    }

    private _onClick_OpenRoomSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvRoom",
            lang.hitch(this, this._onCallback_Dlg),
            null,
            this.roomInput.getAdditionalRequestParams(true)
        );
    }

    private _onCallback_Dlg(mode: string, data, items) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet
        if (!items || items.length == 0) return;

        let entity = {
            ID: items[0].entry.value, gDisp_1: items[0].entry.label
        }

        if (mode == "selectEvRoom") {
            let room = items[0].entry.data;
            this.roomInput.setValue(room);
        }
    }

    private setupHintboxes() {
        this.roomInput.addInlineButton(lang.hitch(this, this._onClick_OpenRoomSED));
    }

    setRequestData(start: Date, end: Date, bookingID: string = null) {
        this.roomInput.addAdditionalRequestParameter('dateStart', start ? this.dateToLocalISOString(start) : null );
        this.roomInput.addAdditionalRequestParameter('dateEnd', end ? this.dateToLocalISOString(end) : null );

        if (bookingID) {
            this.roomInput.addAdditionalRequestParameter('bookingID', bookingID);
        }

    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupHintboxes();

        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";

        this.addOnchanged("___root", lang.hitch(this, this._onChanged_EvRoom));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvBookingRoomSelector);